<script setup lang="ts">
  import { computed, watch, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import BreadcrumbItem from './BreadcrumbItem.vue';
  import { useBreadcrumb } from '@/shared/lib/use/useBreadcrumb';
  import { dynamicBreadcrumbLabel } from '@/shared/lib/navigation/breadcrumbLabel';
  import { breadcrumbTrailOverride } from '@/shared/lib/navigation/breadcrumbTrail';

  const route = useRoute();
  const { updateBreadcrumb, breadcrumb } = useBreadcrumb();

  const isHidden = computed(() => route.meta?.hideBreadcrumb === true);

  watch(() => route.path, updateBreadcrumb);
  watch(() => route.params, updateBreadcrumb, { deep: true });
  watch(() => route.name, updateBreadcrumb);
  watch(dynamicBreadcrumbLabel, updateBreadcrumb);
  watch(breadcrumbTrailOverride, updateBreadcrumb, { deep: true });
  onMounted(updateBreadcrumb);
</script>

<template>
  <div
    v-if="!isHidden && breadcrumb.length > 1"
    id="breadcrumb"
    class="text-right w-full bg-white-02"
  >
    <div class="flex items-center gap-1 justify-end">
      <nav
        aria-label="Breadcrumb"
        class="min-w-0"
      >
        <ol class="flex flex-wrap items-center justify-end gap-1">
          <BreadcrumbItem
            v-for="(item, index) in breadcrumb"
            :key="index"
            :item="item"
            :is-last="index === breadcrumb.length - 1"
          />
        </ol>
      </nav>
    </div>
  </div>
</template>
